class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', {
      bubbles: true
    })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

/*
 * Shopify Common JS
 *
 */

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`
    },
  };
}

if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (let i = 0, count = selector.options.length; i < count; i++) {
    let option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  let method = options['method'] || 'post';
  let params = options['parameters'] || {};

  let form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (let key in params) {
    let hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    let value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    let value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    let opt = this.countryEl.options[this.countryEl.selectedIndex];
    let raw = opt.getAttribute('data-provinces');
    let provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (let i = 0; i < provinces.length; i++) {
        opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (let i = 0; i < values.length; i++) {
      let opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.estimatedDeliveryDate()
    this.addEventListener('change', this.onVariantChange);

    if (this.getAttribute('data-available') == 'false') {
      this.toggleAddButton(window.variantStrings.soldOut, true);
    } else if (this.getAttribute('data-available') == '') {
      if(this.getAttribute('data-type') == 'giftcard'){
        this.toggleAddButton(window.variantStrings.choose_amount, true);
      }
      else if( this.getAttribute('data-variants-size') === '1' ){
        this.toggleAddButton( window.variantStrings.addToCart, false);
      }      
      else {
        this.toggleAddButton(window.variantStrings.choose_variant, true);
      }
    }


    this.updateVariantsLabelsFromStart();

  }

  updateVariantsLabelsFromStart() {
    // Réinitialiser toutes les classes
    document.querySelectorAll('label[data-title]').forEach(label => {
      label.classList.remove('is-active');
    });

    // Récupérer tous les labels des variants
    const labels = document.querySelectorAll('label[data-title]');
    // Créer une map des titres qui doivent être activés
    const activeTitles = new Set();

    labels.forEach(label => {
      const input = label.previousElementSibling;
      if (input && input.checked) {
        activeTitles.add(label.getAttribute('data-title'));
      }
    });

    // Activer tous les labels ayant un data-title correspondant
    labels.forEach(label => {
      if (activeTitles.has(label.getAttribute('data-title'))) {
        label.classList.add('is-active');
      }
    });

    // Récupérer la valeur du data-product-variant-input du main variant
    const mainButton = document.querySelector('#main-button [data-product-variant-input]');
    const variantId = mainButton.value;

    // Injecter la valeur dans l'input[name="id"] dans celui du sticky add to cart
    const stickyInput = document.querySelector('[data-sticky-content-mobile] input[name="id"]');

    if (variantId && stickyInput) {
      stickyInput.value = variantId;
    }
  }


  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantStickyLabels()

    // les labels qui ont [data-id=${this.currentVariantId}].classList.add('is-active)
    this.toggleAddButton('', true, false);
    this.removeErrorMessage();



    if (!this.currentVariant) {
      this.toggleAddButton('', true, true);
      this.setUnavailable();

    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      // this.updateSyncVariantInputs();
      this.renderProductInfo();
    }
  }

  estimatedDeliveryDate() {
    let json = document.querySelector("[data-reassurance-delivery] ul")?.getAttribute("data-reassurance-delivery-json")
    let locale = document.querySelector("[data-reassurance-delivery] ul")?.getAttribute("data-reassurance-locale")
    let firstDate = document.querySelector("[data-reassurance-first-date]")
    if (locale == '' || locale?.split('-').length === 1) {
      locale = 'fr-fr'
    }

    if (firstDate) {
      let datesJson = JSON.parse(json);
      let marketDate = datesJson.livraison_a_domicile[locale]
      if (marketDate === undefined) return false
      let firstEstimatedDate = marketDate.delivery_start
      firstDate.innerHTML = firstEstimatedDate

      if (firstEstimatedDate == "unavailable") {
        document.querySelector('[data-reassurance-delivery]').style.display = 'none'
      } else {
        document.querySelector('[data-reassurance-delivery]').style.display = 'block'

      }
    }


  }

  //Les variants du produits sont syncronisés, et j'ajoute une class is-active sur le label du variant actif.
  updateVariantStickyLabels() {
    const allVariantsInputs = document.querySelectorAll('input[data-input]')
    allVariantsInputs.forEach(input => {
      if (input && input.checked) {
        input.classList.add('is-active!')
      }
    })
    // Clean all label
    const allLabels = document.querySelectorAll('label[data-title]')
    allLabels.forEach(label => label.classList.remove('is-active'))

    // Added is-active
    const allSpecificsLabels = document.querySelectorAll(`label[data-title='${this.currentVariant.title}']`)
    allSpecificsLabels.forEach(label => label.classList.add('is-active'))



  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');

      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', {
        bubbles: true
      }));
    });
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        this.reRenderById(html, `add-${this.dataset.section}`);
        this.reRenderById(html, `price-${this.dataset.section}`);
        this.reRenderById(html, `sticky-${this.dataset.section}`);
        this.reRenderById(html, `sticky-decoy-${this.dataset.section}`);
        this.reRenderById(html, `reinsurance-${this.dataset.section}`);


        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton( this.currentVariant.available ? window.variantStrings.addToCart : window.variantStrings.soldOut , !this.currentVariant.available);
        this.estimatedDeliveryDate()

      });
  }

  // Ici je change reRender les morceaux ayant id {section}-.... 
  // Main Price, Add to cart Price, Sticky Add to cart
  reRenderById(html, id) {
    const source = html.getElementById(id);
    const destination = document.getElementById(id);

    if (source && destination) {
      destination.innerHTML = source.innerHTML;
    }
  }

  toggleAddButton(text, disable = true, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const productFormStickyMobile = document.querySelector("[data-sticky-content-mobile]");


    // Sticky quick add
    const addButtons = productFormStickyMobile?.querySelectorAll('button');

    addButtons?.forEach((addButton) => {
      const addButtonText = addButton.querySelector('span[data-add-to-cart-label]');

      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (addButtonText && text) {
          addButtonText.textContent = text;
        }
      } else {
        addButton.removeAttribute('disabled');
        if (addButtonText) {
          addButtonText.textContent = text ? text : window.variantStrings.addToCart;
        }
      }
    });


    // Main Quick add
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span[data-add-to-cart-label]');


    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;

    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;

    }

    if (!modifyClass) return;

    // show price when choose variant size
    productFormStickyMobile?.querySelector('[data-add-to-cart-price]').classList.remove('u-hidden')

  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      const checkedRadio = Array.from(fieldset.querySelectorAll('input')).find(radio => radio.checked);
      return checkedRadio ? checkedRadio.value : null; // ou une valeur par défaut
    });
  }
}

customElements.define('variant-radios', VariantRadios);